import React from "react"
import {StyledAnchor} from "./component"
import {LinkProps} from "../../index"

// Todo: User Story 385091 - Use global link package
// https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/385091
const StandardLink = ({href, children, dataGaV1, dataGaV2, rel, dataTestId, alignTop}: LinkProps) => {
    const linkProps = {
        href,
        alignTop,
        "data-ga-v1": dataGaV1,
        "data-ga-v2": dataGaV2,
    }

    // eslint-disable-next-line dot-notation
    if (rel) linkProps["rel"] = rel

    return (
        <StyledAnchor {...linkProps} data-testid={dataTestId}>
            {children}
        </StyledAnchor>
    )
}

export default StandardLink
